export class DynamicDateFilter {
	// Use minDateColumnName to calculate the MinDate. Use minDate to explicitly define.
	minDateColumnName: string;
	minDate?: Date;
	// Use maxDateColumnName to calculate the MaxDate. Use maxDate to explicitly define.
	maxDateColumnName: string;
	maxDate?: Date;
	showTime? = true;
	showSeconds? = false;
	increment? = 15;
	format? = 'MM/DD/YY HH:mm';
	firstDay? = 1;
	timePicker24Hours? = true;
	placeholder? = 'Choose Date Range';
}
